'use strict';

const BaseEvent = require('./EventTypes/BaseEvent');


/**
 * Utility class for sending and subscribe to and unsubscribe from Events.
 */
class Events {
    /**
     * Creates and event instance and automatically sends it
     * @param  {String} eventName Event name
     * @param  {Object} data      Event data
     * @return {Promise<Object|Error>} A Promise fulfilled with the data coming from the server
     * @static
     */
    static send (eventName, data) {
        return this._create(eventName, data).send();
    }

    /**
     * Subcribes to an event, allowing to execute a callback each time it is fired
     * @param  {String}   eventName Event name
     * @param  {Function} callback  Function to call once event fires
     * @static
     */
    static subscribe (eventName, callback) {
        return this._create(eventName).subscribe(callback);
    }

    /**
     * Removes the listener of the specified event
     * @param  {String}   eventName Event name
     * @param  {Function} listener  Listener attached to the event,
     *                              necessary for not removing all listeners with the same name
     */
    static unsubscribe (eventName, listener) {
        return this._create(eventName).unsubscribe(listener);
    }

    /**
     * Now we have only one Event type, but it might be helpful some day
     * to handle different types of events in different ways
     * @return {BaseEvent} A new instance of BaseEvent
     * @static
     * @private
     */
    static _create (eventName = '', data = {}) {
        return new BaseEvent(eventName, data);
    }
}

module.exports = Events;



// WEBPACK FOOTER //
// ./src/Events.js